import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MortgageInstructionLender } from '@models/mortgages/mortgage-base';

@Component({
	selector: 'app-lender',
	templateUrl: './lender.component.html',
	standalone: false,
})
export class LenderComponent {
	@Input() name: string;
	@Input() logoUrl: string;
	@Input() shortName: string;

	@Input() set lender(lender: MortgageInstructionLender) {
		this.name = lender?.nameEn;
		this.logoUrl = lender?.logoUrl;
		this.shortName = lender?.shortName;
	}

	@Input() imageWrapperClass = 'mr-3 w-10';
	@Input() showName = true;
	@Input() showShortName = false;
}
